import { apiClient } from '@app/lib'
import { type ApiResponse, type CognitoMfaSettings } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const useMfa = () => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    queryKey: ['mfa'],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<ApiResponse<CognitoMfaSettings>>(`/api/mfa`, { signal })

      return data.data
    },
    staleTime: ms('1h')
  })
}
